import { sortByProp } from '../../../helpers/common'
import { isValidNumber } from '../../../helpers/value'

export const getIds = (data = []) => {
  const parentCodes = data.map((item) => item.parentCode.trim())

  return [...new Set(parentCodes)]
}

export const getDataTable = (data = [], ids = [], defaultVsicId) => {
  const dataTable = {}

  ids.forEach((id) => {
    const group = data.filter((item) => item.parentCode.trim() === id)

    dataTable[id] = [
      ...group.filter((item) => item.organizationType === 'Company'),
      ...group.filter(
        (item) =>
          item.organizationType === 'Industry' && item.vsicId === defaultVsicId,
      ),
      ...group.filter(
        (item) =>
          item.organizationType === 'Industry' && item.vsicId !== defaultVsicId,
      ),
    ].map((item) => {
      const result = {}

      if (item.organizationType === 'Company') {
        result.organizationType = item.organizationType
        result.ratioName = item.ratioName
        result.exchangeRateType = item.exchangeRateType
      }

      result.ratioIndicator = `${item.type}: ${item.typeDescription}`

      item.values.forEach((index) => {
        result[index.realYear] = index.value
        result.type = item.type
        result.unitType = item.unitType
      })

      return result
    })
  })

  return dataTable
}

export const getHeaders = (data = []) => {
  const { values = [] } = data.length ? data[0] : {}

  if (!values.length) {
    return []
  }

  return [
    {
      title: 'companyAnalysis.industryAnalysis.RATIO',
      colId: 'ratioName',
      isI18n: true,
    },
    {
      title: '',
      colId: 'ratioIndicator',
    },
    ...sortByProp(values, 'realYear', false).map((item) => ({
      title: item.realYear,
      colId: item.realYear,
      thStyle: {
        justifyContent: 'flex-end',
      },
    })),
  ]
}

export const handleDataChart = (data = {}, activeRowGroupId, years = []) => {
  return years
    .map((label) => {
      const obj = { isEmpty: true }

      data[activeRowGroupId].forEach((item, index) => {
        if (isValidNumber(item[label])) {
          obj.isEmpty = false
        }

        if (item.organizationType === 'Company') {
          obj.data = item[label]
          obj.unitType = item.unitType
          obj.exchangeRateType = item.exchangeRateType
          obj['name' + index] = item.ratioIndicator
          obj.numKey = data[activeRowGroupId].length
        } else {
          obj['line' + index] = item[label]
          obj['name' + index] = item.ratioIndicator
        }
      })

      return {
        label,
        ...obj,
      }
    })
    .filter((item) => !item.isEmpty)
}
